class OrderForm extends HTMLElement {
  constructor() {
    super();

    this.orderForm = this.querySelector('[js-order-form]');
    this.form = this.querySelector('[js-form]');
    this.submitButton = this.querySelector('[js-submit-button]');
    this.loadingSpinner = this.querySelector('[js-loading-spinner]');

    this.orderDetailsContainer = this.querySelector('[js-order-details]');

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    this.orderNumberInput = this.querySelector('[js-order-number]');
    this.orderNumberInput.value = urlParams.get('order_number') ? urlParams.get('order_number') : '';

    this.form.addEventListener('submit', (e) => {
      e.preventDefault();

      let formData = new FormData(this.form);

      let orderNumber = formData.get('order_number').replace(/[^a-zA-Z0-9]/g, '');
      let lastName = formData.get('order_last_name');

      console.log(orderNumber);

      const url = `https://service-shopify.nestigbaby.com/order/get-ship-dates/${orderNumber}`;

      this.submitButton.classList.add('loading');
      this.loadingSpinner.classList.remove('hidden');

      fetch(url, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer 6ae5b75f-7fa8-4f7f-aee4-ec0d0015c0da',
        },
      })
        .then((response) => response.json())
        .then((response) => {
          this.submitButton.classList.remove('loading');
          this.loadingSpinner.classList.add('hidden');

          let data = response.orderData;

          // if data.cancelled_at is not null, show a message that the order is cancelled
          if (data.cancelled_at) {
            alert('This order has been cancelled');
            return;
          }

          // update the url with the order number
          let nextUrl =
            window.location.protocol +
            '//' +
            window.location.host +
            window.location.pathname +
            '?order_number=' +
            data.order_number;

          window.history.pushState({}, 'Order', nextUrl);

          // check if the last name is the same
          if (data.shipping_address.last_name.toLowerCase() != lastName.toLowerCase())
            throw new Error('Name does not match');

          // set the first line item as active
          this.orderDetailsContainer.dataset.lineItemId = data.line_items[0].id;

          const line_items = data.line_items;

          // add styles
          // Initialize the styles string
          let styles = '';

          // Use map to return the styles for each line_item and join them into one big string
          styles = line_items
            .map((line_item) => {
              return `
                    [data-line-item-id='${line_item.id}'] [data-line-item-id='${line_item.id}'] {
                        display: block;
                    }
                `;
            })
            .join(''); // Join the array of strings into one big string

          this.addStyle(styles);

          // create the steps section for each line item
          let stepsEl = '';

          line_items.forEach((line_item) => {
            const line_item_data = this.getLineItemData(line_item, data);

            console.log(line_item_data);
            console.log(line_item_data.status_messages);

            let status = 'pre-production';
            status = line_item_data.status.building ? 'building' : status;
            status = line_item_data.status.finishing ? 'finishing' : status;
            status = line_item_data.status['in-transit'] ? 'in-transit' : status;

            stepsEl += `
                <div data-line-item-id="${
                  line_item_data.id
                }" class="nb-line-item-steps-container" data-step="${status}">
                    <div class="nb-line-items-steps-inner">
                        <div class="nb-progress-bar-mobile">
                            <div
                            class="nb-progress-bar-line-mobile"
                            ></div>
                        </div>

                        <div class="nb-progress-bar-desktop">
                            <div
                            class="nb-progress-bar-line-desktop"
                            ></div>
                        </div>

                        <div class="nb-line-item-steps">
                            <div class="nb-line-item-steps-title nb-eyebrow">Product Status</div>

                            <div class="nb-line-item-step" data-step="pre-production">
                                <div class="nb-line-item-step-number nb-body-copy-14">
                                    <span class="">1</span>
                                </div>
                                <div>
                                    <div class="nb-line-item-step-title nb-h4">The <em>O</em>rder</div>
                                    <div class="nb-line-item-step-description nb-body-copy-14">
                                        ${
                                          line_item_data?.status_messages
                                            ? line_item_data.status_messages['pre-production']
                                            : ''
                                        }
                                    </div>
                                </div>
                            </div>

                            <div class="nb-line-item-step" data-step="building">
                                <div class="nb-line-item-step-number nb-body-copy-14">
                                    <span class="">2</span>
                                </div>
                                <div>
                                    <div class="nb-line-item-step-title nb-h4">The <em>P</em>roduction</div>
                                    <div class="nb-line-item-step-description nb-body-copy-14">
                                        ${
                                          line_item_data?.status_messages
                                            ? line_item_data.status_messages['building']
                                            : ''
                                        }
                                    </div>
                                </div>
                            </div>

                            <div class="nb-line-item-step" data-step="finishing">
                                <div class="nb-line-item-step-number nb-body-copy-14">
                                    <span class="">3</span>
                                </div>
                                <div>
                                    <div class="nb-line-item-step-title nb-h4">The <em>F</em>inishing <em>T</em>ouches</div>
                                    <div class="nb-line-item-step-description nb-body-copy-14">
                                        ${
                                          line_item_data?.status_messages
                                            ? line_item_data.status_messages['finishing']
                                            : ''
                                        }
                                    </div>
                                </div>
                            </div>

                            <div class="nb-line-item-step" data-step="in-transit">
                                <div class="nb-line-item-step-number nb-body-copy-14">
                                    <span class="">4</span>
                                </div>
                                <div>
                                    <div class="nb-line-item-step-title nb-h4">The <em>J</em>ourney <em>H</em>ome</div>
                                    <div class="nb-line-item-step-description nb-body-copy-14">
                                        ${
                                          line_item_data?.status_messages
                                            ? line_item_data.status_messages['in-transit']
                                            : ''
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `;
          });

          // create the estimated arrival and tracking section
          let trackingEl = '';

          line_items.forEach((line_item) => {
            let fulfillment_item = '';

            for (const fulfillment of data.fulfillments) {
              let has_fulfillment = fulfillment.line_items.find((obj) => {
                return obj.id == line_item.id;
              });

              if (has_fulfillment) {
                fulfillment_item = fulfillment;
              }
            }

            let carrierInfo =
              fulfillment_item != '' && fulfillment_item.tracking_url
                ? `
                <div class='nb-line-item-tracking-carrier'>
                    <div class="nb-body-copy-11-regular">
                        Your tracking information
                    </div>
                    <div class="nb-body-copy-11-regular nb-line-item-tracking-note">
                        <div>
                            Carrier: ${fulfillment_item.tracking_company}
                        </div>
                        <div class='nb-line-item-tracking-number'>
                            <span>Tracking number:</span>
                            <a href='${fulfillment_item.tracking_url}' target='_blank'>${fulfillment_item.tracking_number}</a>
                        </div>
                    </div>
                </div>
            `
                : ``;

            let trackingItem = `<div class='nb-line-item-tracking' data-line-item-id='${line_item.id}'>
                                    <div class="nb-line-item-tracking-inner">
                                        <div class="nb-body-copy-11-regular">Estimated delivery</div>
                                        <div class="nb-body-copy-18-regular nb-line-item-tracking-content">${line_item.status_page_infos.formatted_date_value}</div>
                                        <div class="nb-body-copy-11-regular nb-line-item-tracking-note">
                                            Please note that delivery timelines are estimates and do not take into account any potential carrier delays.
                                        </div>
                                    </div>
                                    ${carrierInfo}
                                </div>`;

            trackingEl += trackingItem;
          });

          // create the images section
          let imagesEl = '';

          const fallbackTemplate = this.querySelector('[js-image-fallback]');
          const fallbackMarkup = fallbackTemplate ? fallbackTemplate.innerHTML.trim() : '';

          line_items.forEach((line_item) => {
            imagesEl += line_item.main_image
              ? `
                            <img src='${line_item.main_image
                              .replace('_500x', '')
                              .concat('&width=1200')}' class='nb-line-item-image' data-line-item-id='${line_item.id}' />
            `
              : `
                            <div class='nb-line-item-image nb-line-item-image-fallback' data-line-item-id='${line_item.id}'>${fallbackMarkup}</div>
            `;
          });

          // create the radios
          let radiosEl = '';

          line_items.forEach((line_item, index) => {
            radiosEl += `
                <input
                    id="${line_item.id}-${index}"
                    type="radio"
                    value="${line_item.id}"
                    name="order-line-item-product"
                    js-radio
                    >
                <label
                    for="${line_item.id}-${index}"
                    class="nb-order-products-label nb-body-copy-13"
                    >
                        ${line_item.title}
            </label>
            `;
          });

          this.orderDetailsContainer.innerHTML = `
                  ${stepsEl}
                  <div class="nb-line-item-products">
                        <div class="nb-line-item-products-details">

                        <h3 class="nb-h3-light">Order ${data.name}</h3>

                        <div class="nb-line-item-products-info">
                            <div class="nb-body-copy-16">Use the dropdown below to view details of each product in your order</div>
                            <details class="nb-order-products" js-details>
                                <summary class="nb-body-copy-13">
                                    <span class="nb-order-products-selected" js-selected>${line_items[0].title}</span>
                                    <span class="nb-icon-chevron">
                                    <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.83264 1.19034C8.05579 0.967177 8.05579 0.605369 7.83264 0.382212C7.6095 0.159054 7.24767 0.159054 7.02453 0.382212L4.00001 3.40673L0.975493 0.382212C0.752333 0.159054 0.390525 0.159054 0.167368 0.382212C-0.0557893 0.605369 -0.0557893 0.967177 0.167368 1.19034L3.59594 4.61892C3.8191 4.84207 4.18091 4.84207 4.40407 4.61892L7.83264 1.19034Z" fill="#0A0A0A"></path>
                                    </svg>
                                    </span>
                                </summary>
                                <div class="nb-order-products-dropdown" js-addon-dropdown="">
                                    ${radiosEl}
                                </div>
                            </details>
                            <button type='button' class='nb-button nb-reset' js-reset>Search for another order</button>
                        </div>

                        ${trackingEl}

                      </div>

                      <div class="nb-line-item-products-images">
                        ${imagesEl}
                      </div>
                  </div>
              `;

          this.activateElement();

          this.dataset.results = 'true';
        })
        .catch((error) => {
          console.log(error);
          this.submitButton.classList.remove('loading');
          this.loadingSpinner.classList.add('hidden');

          if (error.message == 'Name does not match') {
            alert('Name does not match!');
          } else {
            alert('No order found!');
          }

          return;
        });
    });
  }

  getLineItemData(line_item, data = null) {
    const today = new Date();
    const created_at_date = data ? new Date(data.created_at) : new Date();

    const diffTime = Math.abs(today - created_at_date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    let status = {
      'pre-production': true,
      building: false,
      finishing: false,
      'in-transit': false,
    };

    const shipDate = new Date(line_item.ship_date);
    const totalTime = Math.abs(shipDate - created_at_date);
    const totalTimeDays = Math.ceil(totalTime / (1000 * 60 * 60 * 24));

    let estimated_delivery = new Date();
    estimated_delivery.setDate(created_at_date.getDate() + totalTimeDays);

    let options = { year: 'numeric', month: 'long', day: 'numeric' };
    let estimated_delivery_date = estimated_delivery.toLocaleDateString('en-US', options);

    if (diffDays > 0.2 * totalTimeDays) {
      status['building'] = true;
    }

    if (diffDays > 0.95 * totalTimeDays) {
      status['finishing'] = true;
    }

    if (line_item.fulfillment_status == 'fulfilled') {
      status = {
        'pre-production': true,
        building: true,
        finishing: true,
        'in-transit': true,
      };
    }

    line_item.status = status;

    switch (line_item.product_type) {
      case 'Cribs':
        line_item['status_messages'] = {
          'pre-production': 'We send your order to our heritage manufacturers in Brazil.',
          building: 'Our team of local artisans build your made-to-order crib.',
          finishing: 'Your finished crib is prepped for shipping and carefully packed up.',
          'in-transit': 'Your crib is sent directly to you — from Brazil, with love.',
        };
        break;
      case 'Dressers':
        line_item['status_messages'] = {
          'pre-production': 'We send your order to our heritage manufacturers in Brazil.',
          building: 'Our team of local artisans build your made-to-order dresser.',
          finishing: 'Your finished dresser is prepped for shipping and carefully packed up.',
          'in-transit': 'Your dresser is sent directly to you — from Brazil, with love.',
        };
        break;
      case 'Shelves':
        line_item['status_messages'] = {
          'pre-production': 'We send your order to our heritage manufacturers in Brazil.',
          building: 'Our team of local artisans build your made-to-order shelf.',
          finishing: 'Your finished shelf is prepped for shipping and carefully packed up.',
          'in-transit': 'Your shelf is sent directly to you — from Brazil, with love.',
        };
        break;
      case 'Rugs':
        line_item['status_messages'] = {
          'pre-production': 'We send your order to our heritage manufacturers in Brazil.',
          building: 'Our team of local artisans loom and dye your made-to-order rug.',
          finishing: 'Your finished rug is prepped for shipping and carefully packed up.',
          'in-transit': 'Your rug is sent directly to you — from Brazil, with love.',
        };
        break;
      case 'Sheets':
        line_item['status_messages'] = {
          'pre-production': 'We send your order to our heritage manufacturers in Brazil.',
          building: 'Our team of local artisans cut and sew your sheets.',
          finishing: 'Your finished sheets are prepped for shipping and carefully packed up.',
          'in-transit': 'Your sheets are sent directly to you — from Brazil, with love.',
        };
        break;
      case 'Mattress':
        line_item['status_messages'] = {
          'pre-production': 'We send your order to our manufacturing partner in the US.',
          building: 'Their state of the art team assembles all components for the mattress.',
          finishing: 'Your finished mattress is prepped for shipping and carefully packed up.',
          'in-transit': 'Your mattress is sent directly to you, with love.',
        };
        break;
      case 'Mobiles':
        line_item['status_messages'] = {
          'pre-production': 'We send your order to our heritage manufacturers in Brazil.',
          building: 'Our team of local artisans assembles your mobile by hand.',
          finishing: 'Your finished mobile is prepped for shipping and carefully packed up.',
          'in-transit': 'Your mobile is sent directly to you — from Brazil, with love.',
        };
        break;
      case 'Quilts':
        line_item['status_messages'] = {
          'pre-production': 'We send your order to our heritage manufacturers in Brazil.',
          building: 'Our team of local artisans sews your quilt by hand.',
          finishing: 'Your finished quilt is prepped for shipping and carefully packed up.',
          'in-transit': 'Your quilt is sent directly to you — from Brazil, with love.',
        };
        break;
      case 'Wallpaper':
        line_item['status_messages'] = {
          'pre-production': 'We send your order to our printing partner in Brazil.',
          building: 'Your batch is printed and inspected by hand.',
          finishing: 'Your wallpaper is carefully prepped for shipping.',
          'in-transit': 'Your wallpaper is sent directly to you, with love.',
        };
        break;
      case 'Curtain':
        line_item['status_messages'] = {
          'pre-production': 'We send your order to our heritage manufacturers in Brazil.',
          building: 'Our team of local artisans sew your curtains.',
          finishing: 'Your curtains are prepped for shipping and carefully packed up.',
          'in-transit': 'Your curtains are sent directly to you — from Brazil, with love.',
        };
        break;
      default:
    }

    return line_item;
  }

  activateElement() {
    const details = this.querySelector('[js-details]');
    const selected = details.querySelector('[js-selected]');
    const radios = details.querySelectorAll('[js-radio]');
    radios.forEach((radio) =>
      radio.addEventListener('change', () => {
        this.orderDetailsContainer.dataset.lineItemId = radio?.value;
        details.removeAttribute('open');
        selected.textContent = radio?.nextElementSibling.textContent;
      })
    );
    const reset = this.querySelector('[js-reset]');
    reset.addEventListener('click', () => {
      this.dataset.results = 'false';
    });
  }

  isValidDate(d) {
    return d == 'Invalid Date';
  }

  addStyle(styleString) {
    const style = document.createElement('style');
    style.textContent = styleString;
    this.append(style);
  }
}

customElements.define('order-form-component', OrderForm);
